// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"92331d84","97":"ecc1182e","124":"91f81d58","148":"7f999e75","228":"cd7b4df4","247":"2e46f032","265":"66c4e597","270":"6014dbcf","453":"c3d287a5","644":"3b48661c","852":"767aa2d3","987":"c050d79a"}[chunkId] + ".chunk.js";
};